export const prettifiedAPIUserErrors = {
  'Please enter a valid First Name':
    'Please enter a valid first name using only letters, hyphens, apostrophes, and spaces.',
  'Please enter a valid Last Name':
    'Please enter a valid first name using only letters, hyphens, apostrophes, and spaces.',
};
